export const selectReducer = (state) => state.templateInfo;

export const selectSingleAsset = (state) =>
  selectReducer(state) ? selectReducer(state).get('singleAsset') : undefined;
